<br>
<ng-container>

    <p class="textSubHeader">
        Mi agenda
    </p>
    
    <p class="textHeader">
        Configurar agenda
    </p>
</ng-container>

<div class="row mb-2 mb-sm-4 mt-sm-4">
    <div class="col-12">
        <h3 class="mb-1">¿Que modalidad de consultas desea configurar?</h3>
        <div class="card-deck flex-column flex-md-row">
            <div class="card mb-3" style="border-color: #0e0087;">
                <div class="image-container">
                    <img class="card-img-top" src="assets/images/home/utilizar-1.jpg" alt="utilizar alamedis 1">
                </div>
                <div class="card-block card-block-custom">
                    <p class="card-text" style="color: #0e0087">Agendamiento</p>
                    <p class="card-text">  Configura las agendas de los médicos permitiendo que los pacientes reserven consultas en horarios definidos según su disponibilidad.
                    </p>
                    <div class="buttons-box row">
                       
                        <div class="col">
                            <button type="button" (click)="configuracionReserva()" class="btn btn-primary">
                                Configurar
                            </button>

                        </div>
                    </div>
                </div>
            </div>
            
            <div class="card mb-3" style="border-color: #2babb7;">
                <div class="image-container">
                    <img class="card-img-top" src="assets/images/home/utilizar-3.jpg" alt="utilizar alamedis 1">
  
                  </div>
                  
                
                  <div class="card-block card-block-custom">
                    <p class="card-text" style="color: #2BABB7">Atención inmediata</p>
                    <p class="card-text">
                      Habilita a los médicos para atender pacientes en tiempo real mediante la modalidad de "atención inmediata", priorizando consultas rápidas cuando estén disponibles.
                    </p>
                    <div class="buttons-box row">
                      <div class="col">
                        <button type="button" (click)="configuracionOnDemand()" class="btn btn-primary" style="background-color: #2AC9CE;">
                          Configurar
                        </button>
                      </div>
                    </div>
                  </div>
                  
            </div>
        </div>
    </div>
</div>